export const createEventSlug = (eventTitle: string, uniqueId: string): string => {
  // Create SEO-friendly slug from event title
  const slug = eventTitle
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/[\s_-]+/g, '-') // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
    .substring(0, 50); // Limit length
  
  // Add unique ID to ensure uniqueness
  return `${slug}-${uniqueId}`;
};

export const parseEventSlug = (slug: string): string | null => {
  // Extract uniqueId from the end of the slug
  const parts = slug.split('-');
  if (parts.length === 0) return null;
  
  // The uniqueId should be the last part after the final hyphen
  return parts[parts.length - 1];
};

export const generateEventUrl = (event: { eventTitle: string; uniqueId: string }): string => {
  const slug = createEventSlug(event.eventTitle, event.uniqueId);
  return `/event/${slug}`;
};